import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Clock, Heart } from 'react-feather';
import { CRONOS_URL, ECHO_URL, NUESTRA_URL, PACOCA_TRANSLATE_URL, PACOCA_URL, READBOOKS_URL, VERSONA_URL } from '../../utils/vars';
import { navigateNav } from '../../utils/nav';
import { CaseSensitive, HeartCrack, LayoutGrid, Music2, ScrollText } from 'lucide-react';
import { Icon } from '../icon';
import { useTheme } from '../../contexts/theme-context';
import { useTranslation } from "react-i18next";

const AppsNavbarRight  = ({ currentApp = "pacoca" }: { currentApp?: string }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isDarkMode } = useTheme();

    return (
        <>
            <span  data-bs-toggle="dropdown" aria-expanded="false" className="link-menu-right dropdown-item color-red">
                <span className="dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {/* <LayoutGrid className='menu-father-icon'/> */}
                    <Icon invertColor={!isDarkMode} name="apps" size={30}>
                        <LayoutGrid className='menu-father-icon'/> 
                    </Icon> {t("settings.apps")}
                    
                </span>
        
                <ul className="dropdown-menu cursor-pointer" aria-labelledby="navbarDropdown" style={{ width: "100%" }}>
                    {currentApp != "pacoca" ? (
                        <li>
                            <span onClick={(e) => navigateNav(navigate, PACOCA_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                                <Heart style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Paçoca
                            </span>
                        </li>
                    ): null}

                    {/* {currentApp != "readbooks" ? (
                        <li>
                            <span onClick={(e) => navigateNav(navigate, READBOOKS_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                                <BookOpen style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Read Books
                            </span>
                        </li>
                    ): null}

                    {currentApp != "echo" ? (
                        <li>
                            <span onClick={(e) => navigateNav(navigate, ECHO_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                                <Music2 style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Echo
                            </span>
                        </li>
                    ): null} */}


                    {currentApp != "versona" ? (
                        <li>
                            <span onClick={(e) => navigateNav(navigate, VERSONA_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                                <ScrollText style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Versona
                            </span>
                        </li>
                    ): null}

                    {/* {currentApp != "translate" ? (
                        <li>
                            <span onClick={(e) => navigateNav(navigate, PACOCA_TRANSLATE_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                                <CaseSensitive style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Paçoca Translate
                            </span>
                        </li>
                    ): null} */}
                    
                    {/* <li>
                        <span onClick={(e) => navigateNav(navigate, CRONOS_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                            <Clipboard style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                            Rita
                        </span>
                    </li> */}
                    
                    {/* {currentApp != "cronos" ? (
                        <li>
                            <span onClick={(e) => navigateNav(navigate, CRONOS_URL, e)} className="link-menu-right dropdown-item d-flex align-items-center">
                                <Clock style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Cronos
                            </span>
                        </li>
                    ): null} */}
                </ul>
            </span>
        </>
    );
};

export default AppsNavbarRight;
